



import { MdOutlineCurrencyRupee } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import React, { useState, useEffect } from "react";
import { FaInfoCircle } from "react-icons/fa";
import axios from "axios";
import "./productpreview.css";
import { Underline } from "lucide-react";
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
const ProductPreview = () => {
  const location = useLocation();
  const { productId } = location.state || {};

  const [duration, setDuration] = useState(1);
  const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
  const [deliveryDate, setDeliveryDate] = useState(today);
  const [returnDate, setReturnDate] = useState("");
  const [salePrice, setSalePrice] = useState("");
  const [originalPrice,setOriginalPrice] =useState("");
  const [product, setProduct] = useState({});
  const [sizes, setSizes] = useState([]);
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedSizeDetails, setSelectedSizeDetails] = useState(null);
  const [activeImage, setActiveImage] = useState(0); // For image thumbnail switching
  const [activeTab, setActiveTab] = useState("Inches");

  const openCity = (Size) => {
    setActiveTab(Size);
  };

  // useEffect(() => {
  //   const currentDate = new Date();
  //   setDeliveryDate(currentDate.toISOString().split("T")[0]);

  //   const returnDate = new Date(currentDate);
  //   if (duration === 1) {
  //     returnDate.setDate(currentDate.getDate() + duration + 1);
  //   } else {
  //     returnDate.setDate(currentDate.getDate() + duration - 1);
  //   }

  //   setReturnDate(returnDate.toISOString().split("T")[0]);
  // }, [duration]);


  useEffect(() => {
    if (deliveryDate) {
      const currentDate = new Date(deliveryDate);
      const newReturnDate = new Date(currentDate);

      if (duration === 1) {
        newReturnDate.setDate(currentDate.getDate() + duration + 1);
      } else {
        newReturnDate.setDate(currentDate.getDate() + duration - 1);
      }

      setReturnDate(newReturnDate.toISOString().split('T')[0]);
    }
  }, [deliveryDate, duration]);
  useEffect(() => {
    if (productId) {
      axios
        .get(`/productsview/${productId}`)
        .then((response) => {
          setSizes(response.data.size);
          setProduct(response.data);
          setSalePrice(response.data.salePrice);
          setOriginalPrice(response.data.originalPrice)
        })
        .catch((error) => {
          console.error("Error fetching product details:", error);
        });
    }
  }, [productId]);

  const handleSizeSelect = (event) => {
    const selectedSizeValue = event.target.value;
    setSelectedSize(selectedSizeValue);

    const sizeDetails = sizes.find((size) => size.sizeId === selectedSizeValue);
    setSelectedSizeDetails(sizeDetails);
  };

  const handleAddToCart = () => {
    if (!selectedSize) {
      alert("Please select a size");
      return;
    }

    const cartItem = {
      id: productId,
      productName: product.productName,
      size: selectedSizeDetails.size,
      sizeId: selectedSizeDetails.sizeId,
      duration: duration,
      originalPrice:originalPrice,
      salePrice: salePrice,
      image: product.images[0]?.url,
      deliveryDate: deliveryDate,
      returnDate: returnDate,
    };

    const existingCart = JSON.parse(localStorage.getItem("cartItems") || "[]");

    if (existingCart.length > 0) {
      const { deliveryDate: existingDeliveryDate, returnDate: existingReturnDate } = existingCart[0];

      if (cartItem.deliveryDate !== existingDeliveryDate || cartItem.returnDate !== existingReturnDate) {
        alert(
          `Delivery date and return date must match the existing items in the cart:
          - Delivery Date: ${existingDeliveryDate}
          - Return Date: ${existingReturnDate}`
        );
        return;
      }
    }

    const existingItemIndex = existingCart.findIndex(
      (item) => item.id === cartItem.id && item.sizeId === cartItem.sizeId
    );

    if (existingItemIndex > -1) {
      existingCart[existingItemIndex] = cartItem;
    } else {
      existingCart.push(cartItem);
    }

    localStorage.setItem("cartItems", JSON.stringify(existingCart));
    window.location.href = "/cart";
  };

  const handleDurationChange = (event) => {
    const newDuration = parseInt(event.target.value);
    setDuration(newDuration);

    const priceAdjustments = {
      1: 0,
      4: 0.2,
      6: 0.3,
      8: 0.4,
      10: 0.5,
      12: 0.6,
    };

    const adjustment = priceAdjustments[newDuration] || 0;
    setSalePrice(product.salePrice + product.salePrice * adjustment);
  };

  const handleThumbnailClick = (index) => {
    setActiveImage(index);
  };

  const handleMouseMove = (e) => {
    const container = e.currentTarget;
    const image = container.querySelector("img");

    const containerWidth = container.offsetWidth;
    const containerHeight = container.offsetHeight;

    const x = e.nativeEvent.offsetX;
    const y = e.nativeEvent.offsetY;

    const translateX = (containerWidth / 2 - x) * 2;
    const translateY = (containerHeight / 2 - y) * 2;

    const scale = 3;

    image.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
  };
  const sizeMap = {
    34: "XS",
    36: "S",
    38: "M",
    40: "L",
    42: "XL",
    44: "2XL",
    46: "3XL",
    48: "4XL",
  };
  const handleMouseLeave = (e) => {
    const image = e.currentTarget.querySelector("img");
    image.style.transform = "translate(0%, 0%) scale(1)";
  };
  const handleDeliveryDateChange = (e) => {
    setDeliveryDate(e.target.value);
  };
  return (
    <>
      <section className="flat-spacing-4 pt_4">
        <div className="tf-main-product section-image-zoom">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="tf-product-media-wrap sticky-top gallery_zoom_container">
                  {/* Thumbnail Navigation */}
                  <section className="thumbnail_1">
                    {product.images?.map((image, index) => (
                      <div
                        key={index}
                        className={`thumbnailBox_1 ${index === activeImage ? "active" : ""}`}
                        onClick={() => handleThumbnailClick(index)}
                      >
                        <img src={`${image.url.trim()}`} alt={`Thumbnail ${index + 1}`} className="otherproduct" />
                      </div>
                    ))}
                  </section>
                  {/* Main Image with Zoom Effect */}
                  <section
                    className="mainImage_1"
                    onMouseMove={handleMouseMove}
                    onMouseLeave={handleMouseLeave}
                  >
                    <img
                      src={`${product.images?.[activeImage]?.url.trim()}`}
                      alt="Main"
                    />
                  </section>

                </div>
              </div>
              <div className="col-md-6">
                <div className="tf-product-info-title">
                  <strong>{product.productName}</strong>
                </div>
                <div>
                  {selectedSize && (
                    <div className="mt-4">
                      <p style={{fontWeight:"600" ,marginBottom:"3vh",fontSize:"20px"}}>{selectedSize}</p>
                    </div>
                  )}
                </div>
                <div className="tf-product-info-price">
                  <div className="price-on-sale" id="current-price">
                    <MdOutlineCurrencyRupee />
                  </div>
                  <span className="price">{salePrice}</span>
                  <div className="price-on-sale" id="old-price">
                    <MdOutlineCurrencyRupee />
                  </div>
                  <p className="mrp-p1">{product.originalPrice}</p>
                  <span>MRP (inclusive of all taxes )</span>
                  <div className="badges-on-sale">
                    <span>{product.discount}</span>% OFF
                  </div>
                </div>
                <div className="refundlabel" id="current-price">
                  Refundable Security Deposit :<MdOutlineCurrencyRupee />
                  {salePrice}
                </div>
                <br />

                <div class="image-container karthik_popup image">
                  <FaInfoCircle className="" />
                  <div class="popup" style={{ zIndex: "200" }}>
                    <div class="price-chart">
                      <h2>Rental Price Chart</h2>
                      <table>
                        <thead>
                          <tr>
                            <th>Days</th>
                            <th>Price</th>
                            <th>Deposit</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>{product.salePrice}</td>
                            <td>{product.salePrice}</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>{product.salePrice + product.salePrice * 0.2}</td>
                            <td>{product.salePrice + product.salePrice * 0.2}</td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>{product.salePrice + product.salePrice * 0.3}</td>
                            <td>{product.salePrice + product.salePrice * 0.3}</td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>{product.salePrice + product.salePrice * 0.4}</td>
                            <td>{product.salePrice + product.salePrice * 0.4}</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>{product.salePrice + product.salePrice * 0.5}</td>
                            <td>{product.salePrice + product.salePrice * 0.5}</td>
                          </tr>
                          <tr>
                            <td>12</td>
                            <td>{product.salePrice + product.salePrice * 0.6}</td>
                            <td>{product.salePrice + product.salePrice * 0.6}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>Price May Change When Rent Days Increased After 1 Day
                <li className="sizechart"><a href="#login" data-bs-toggle="modal" class="nav-icon-item" style={{ color: "green", textDecoration: "Underline" }}>SizeChart</a></li>
                <div className="quantity-title fw-7 mb-2">Size</div>
                <div>
                  <ul className="d-flex flex-wrap gap-2 p-0">
                    {/* {sizes.map((size) =>
                      size.quantity >= 1 ? (
                        <li key={size.sizeId}>
                          <input
                            onClick={handleSizeSelect}
                            type="radio"
                            name="variant_sku"
                            value={size.sizeId}
                            id={`size-${size.sizeId}`}
                            required
                            className="btn-check"
                            style={{ fontFamily: "cursive" }}
                          />
                          <label
                            htmlFor={`size-${size.sizeId}`}
                            className="btn btn-outline-dark size-box"
                          >
                            {size.size}
                          </label>
                        </li>
                      ) : null
                    )} */}


                    {sizes.map((size) =>
                      size.quantity >= 1 ? (
                        <div >
                        <li key={size.sizeId} className="inputhover">
                          <input
                            onClick={handleSizeSelect}
                            type="radio"
                            name="variant_sku"
                            value={size.sizeId}
                            id={`size-${size.sizeId}`}
                            required
                            className="btn-check"
                          />
                          <label
                            htmlFor={`size-${size.sizeId}`}
                            className="btn btn-outline-dark size-box"
                          >
                             {sizeMap[size.size]}
                          </label>
                          
                        </li>
                        {size.size}
                        </div>
                      ) : null
                      
                    )}

                  </ul>
                </div>
                <div className="tf-product-info-quantity" style={{ marginTop: "20px" }}>
                  <div className="quantity-title fw-6">Duration (days)</div>
                  <ul className="tf-pagination-list tf-pagination-btn d-flex gap-2" style={{ listStyle: "none" }}>
                    {[1, 4, 6, 8, 10, 12].map((day) => (
                      <li key={day} className="inputhover">
                        <input
                          onClick={handleDurationChange}
                          type="radio"
                          name="variant_sku1"
                          value={day}
                          id={`day-${day}`}
                          required
                          defaultChecked={day === 1}
                          className="btn-check"
                        />
                        <label
                          htmlFor={`day-${day}`}
                          className="btn btn-outline-dark size-box"
                        >
                          {day}
                        </label>
                      </li>
                    ))}
                  </ul>
                </div>
                <br />
                <div className="tf-product-info-quantity">
                  <div className="d-flex">
                    <div className="quantity-title fw-6 me-3 d-flex flex-column">
                      <span>Delivery On</span>
                      <input type="date" className="quantity-product" value={deliveryDate} onChange={handleDeliveryDateChange}   style={{fontSize:"18px"}}/>
                    </div>
                    <div className="quantity-title fw-6 me-3 d-flex flex-column">
                      <span>Return By</span>
                      <input type="date" className="quantity-product" value={returnDate} readOnly style={{fontSize:"18px"}}/>
                    </div>
                  </div>
                </div>
                <br />
                <div
                  className="tf-product-info-buy-button"
                  style={{ display: "flex", flexDirection: "row"}}
                >
                  <button
                    type="button"
                    onClick={handleAddToCart}
                    className="tf-btn btn-fill justify-content-center inputhover"
                    style={{ marginRight: "20px",width:"40%" }}
                  >
                    <span>ADD TO CART</span>

                  </button>
                  <button
                    type="button"
                    onClick={handleAddToCart}
                    className="tf-btn btn-fill justify-content-center inputhover"
                    style={{ marginRight: "20px",width:"40%"  }}
                  >
                    <span>RENT ROYALTY</span>
                  </button>
                </div>
              </div>
            </div>
            <hr />
            <div className="ProductInformation" >
              <h5 style={{ textAlign: "center", textDecoration: "underline" }}>Product Information</h5>
              <ul>
                <li>Product ID : <b>{product.productId}</b></li>
                {/* {product.categories.map((category) => (
                  <span>
                    {category.name}
                  </span>
                ))} */}
                {product?.categories?.length > 0 ? (
                  <ul>

                    {product.categories.map((category) => (
                      <li key={category.id}>Product Type: <b>{category.name}</b></li>
                    ))}
                  </ul>
                ) : (
                  <p>{product.productName}</p>
                )}
                <li className="d-flex gap-2 ">ShoulderSize:

                  {sizes.map((s) => (
                    <li key={s.sizeId}>
                      <b>{s.size}</b>
                    </li>
                  ))}
                </li>
                <li>Made In India</li>
                <li>Marketer: <b>RoyalHood #29, 1st Floor, BTM 2nd Stage,
                  Bannerghatta Main Road,
                  Opposite To Gopalan Mall,
                  Next Jayadeva Metro Station,
                  Bangalore - 560076</b></li>
              </ul>
            </div>
          </div>
        </div>
        {/* size chart start */}
        <div class="modal modalCentered fade form-sign-in modal-part-content" id="login">
          <div class="modal-dialog modal-dialog-centered">

            <div class="modal-content" >
              <div class="header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div class="tab" >
                  <button
                    className={`tf-btn style-2 btn-fill radius-3 animate-hover-btn ${activeTab === "Inches" ? "active" : ""}`}
                    onClick={() => openCity("Inches")}

                  >
                    Inches
                  </button>
                  <button
                    className={`tf-btn style-2 btn-fill radius-3 animate-hover-btn ${activeTab === "Centimeter" ? "active" : ""}`}
                    onClick={() => openCity("Centimeter")}
                    style={{ marginLeft: "10px" }}
                  >
                    Centimeter
                  </button>
                </div>
                <span class="icon-close icon-close-popup" data-bs-dismiss="modal" ><IoClose /></span>
              </div>


              <div id="Inches"
                className="tabcontent"
                style={{ display: activeTab === "Inches" ? "block" : "none" }}>
                <div style={{ backgroundColor: "#00150f", width: "100%", height: "auto", padding: "10px", textAlign: "center", color: "#efcf9a", marginBottom: "10px" }}>
                  <h5 style={{ color: "#efcf9a", fontFamily: "Raleway,serif" }}>ROYALHOOD SUIT SIZE CHART</h5>
                </div>

                <p>Sizes Mentioned In (Inches)</p>

                <table class="size-chart">
                  <thead>
                    <tr>
                      <th>Size</th>
                      <th>Chest</th>
                      <th>Waist</th>
                      <th>Neck</th>
                      <th>Sleeve</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><b>XS</b></td>
                      <td>32 - 34</td>
                      <td>26 - 28</td>
                      <td>13 - 13.5</td>
                      <td>31 - 32</td>
                    </tr>
                    <tr>
                      <td><b>S</b></td>
                      <td>35 - 37</td>
                      <td>29 - 31</td>
                      <td>14 - 14.5</td>
                      <td>32 - 33</td>
                    </tr>
                    <tr class="highlight">
                      <td><b>M</b></td>
                      <td>38 - 40</td>
                      <td>32 - 34</td>
                      <td>15 - 15.4</td>
                      <td>33 - 34</td>
                    </tr>
                    <tr>
                      <td><b>L</b></td>
                      <td>41 - 46</td>
                      <td>35 - 37</td>
                      <td>16 - 16.5</td>
                      <td>34 - 35</td>
                    </tr>
                    <tr>
                      <td><b>XL</b></td>
                      <td>44 - 46</td>
                      <td>38 - 40</td>
                      <td>17 - 17.5</td>
                      <td>35 - 36</td>
                    </tr>
                    <tr>
                      <td><b>XXL</b></td>
                      <td>47 - 49</td>
                      <td>41 - 43</td>
                      <td>18 - 18.5</td>
                      <td>35 - 37</td>
                    </tr>
                  </tbody>
                </table>


                <div style={{ backgroundColor: "#00150f", width: "100%", height: "auto", padding: "10px", textAlign: "center", color: "#efcf9a", marginBottom: "10px" }}>
                  <h5 style={{ color: "#efcf9a", fontFamily: "Raleway,serif" }}>ROYALHOOD SHIRT SIZE CHART</h5>
                </div>

                <p>Sizes Mentioned In (Inches)</p>

                <table class="size-chart">
                  <thead>
                    <tr>
                      <th>Size</th>
                      <th>Chest</th>
                      <th>Sleeve</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><b>XS</b></td>
                      <td>32 - 34</td>
                      <td>33.5</td>
                    </tr>
                    <tr>
                      <td><b>S</b></td>
                      <td>35 - 37</td>
                      <td>34.5</td>
                    </tr>
                    <tr>
                      <td ><b>M</b></td>
                      <td >38 - 40</td>
                      <td >35.5</td>
                    </tr>
                    <tr>
                      <td><b>L</b></td>
                      <td>41 - 46</td>
                      <td>36.5</td>
                    </tr>
                    <tr>
                      <td ><b>XL</b></td>
                      <td >44 - 46</td>
                      <td >37.5</td>
                    </tr>
                    <tr>
                      <td><b>XXL</b></td>
                      <td>47 - 49</td>
                      <td>38.5</td>
                    </tr>
                  </tbody>
                </table>


                <div style={{ backgroundColor: "#00150f", width: "100%", height: "auto", padding: "10px", textAlign: "center", color: "#efcf9a", marginBottom: "10px" }}>
                  <h5 style={{ color: "#efcf9a", fontFamily: "Raleway,serif" }}>ROYALHOOD PANT SIZE CHART</h5>
                </div>

                <p>Sizes Mentioned In (Inches)</p>

                <table>
                  <thead>
                    <tr>
                      <th>Size</th>
                      <th>Waist</th>
                      <th>Inseam</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><b>XS</b></td>
                      <td>24 - 26</td>
                      <td>28 - 30</td>
                    </tr>
                    <tr>
                      <td><b>S</b></td>
                      <td>27 - 29</td>
                      <td>30 - 32</td>
                    </tr>
                    <tr>
                      <td ><b>M</b></td>
                      <td >30 - 32</td>
                      <td >30 - 32</td>
                    </tr>
                    <tr>
                      <td><b>L</b></td>
                      <td>33 - 35</td>
                      <td>32 - 34</td>
                    </tr>
                    <tr>
                      <td ><b>XL</b></td>
                      <td >36 - 38</td>
                      <td >32 - 34</td>
                    </tr>
                    <tr>
                      <td><b>XXL</b></td>
                      <td>39 - 41</td>
                      <td>32 - 34</td>
                    </tr>
                  </tbody>
                </table>


              </div>


              <div
                id="Centimeter"
                className="tabcontent"
                style={{ display: activeTab === "Centimeter" ? "block" : "none" }}
              >

                <div style={{ backgroundColor: "#00150f", width: "100%", height: "auto", padding: "10px", textAlign: "center", color: "#efcf9a", marginBottom: "10px" }}>
                  <h5 style={{ color: "#efcf9a", fontFamily: "Raleway,serif" }}>ROYALHOOD SUIT SIZE CHART</h5>
                </div>

                <p>Sizes Mentioned In (Centimeter)</p>


                <table>
                  <thead>
                    <tr>
                      <th>Size</th>
                      <th>Chest</th>
                      <th>Waist</th>
                      <th>Neck</th>
                      <th>Sleeve</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><b>XS</b></td>
                      <td>81 - 86</td>
                      <td>66 - 71</td>
                      <td>33 - 34</td>
                      <td>79 - 81</td>
                    </tr>
                    <tr>
                      <td><b>S</b></td>
                      <td>89 - 94</td>
                      <td>74 - 79</td>
                      <td>36 - 37</td>
                      <td>81 - 84</td>
                    </tr>
                    <tr>
                      <td ><b>M</b></td>
                      <td >97 - 102</td>
                      <td >81 - 86</td>
                      <td >38 - 39</td>
                      <td >84 - 86</td>
                    </tr>
                    <tr>
                      <td><b>L</b></td>
                      <td>104 - 117</td>
                      <td>89 - 94</td>
                      <td>41 - 42</td>
                      <td>86 - 89</td>
                    </tr>
                    <tr>
                      <td ><b>XL</b></td>
                      <td >112 - 117</td>
                      <td >97 - 102</td>
                      <td >43 - 44</td>
                      <td >89 - 91</td>
                    </tr>
                    <tr>
                      <td><b>XXL</b></td>
                      <td>119 - 124</td>
                      <td>104 - 109</td>
                      <td>46 - 47</td>
                      <td>89 - 94</td>
                    </tr>
                  </tbody>
                </table>


                <div style={{ backgroundColor: "#00150f", width: "100%", height: "auto", padding: "10px", textAlign: "center", color: "#efcf9a", marginBottom: "10px" }}>
                  <h5 style={{ color: "#efcf9a", fontFamily: "Raleway,serif" }}>ROYALHOOD SHIRT SIZE CHART</h5>
                </div>

                <p>Sizes Mentioned In (Centimeter)</p>


                <table>
                  <tr>
                    <th>Size</th>
                    <th>Chest</th>
                    <th>Sleeve</th>
                  </tr>
                  <tr>
                    <td><b>XS</b></td>
                    <td>81 - 86</td>
                    <td>85</td>
                  </tr>
                  <tr>
                    <td><b>S</b></td>
                    <td>89 - 94</td>
                    <td>88</td>
                  </tr>
                  <tr>
                    <td><b>M</b></td>
                    <td>97 - 102</td>
                    <td>90</td>
                  </tr>
                  <tr>
                    <td><b>L</b></td>
                    <td>104 - 117</td>
                    <td>93</td>
                  </tr>
                  <tr>
                    <td><b>XL</b></td>
                    <td>112 - 117</td>
                    <td>95</td>
                  </tr>
                  <tr>
                    <td><b>XXL</b></td>
                    <td>119 - 124</td>
                    <td>98</td>
                  </tr>
                </table>




                <div style={{ backgroundColor: "#00150f", width: "100%", height: "auto", padding: "10px", textAlign: "center", color: "#efcf9a", marginBottom: "10px" }}>
                  <h5 style={{ color: "#efcf9a", fontFamily: "Raleway,serif" }}>ROYALHOOD PANT SIZE CHART</h5>
                </div>

                <p>Sizes Mentioned In (Centimeter)</p>

                <table >
                  <tr>
                    <th>Size</th>
                    <th>Waist</th>
                    <th>Inseam</th>
                  </tr>


                  <tbody class="cm-values" >
                    <tr><td><b>XS</b></td><td>61 - 66</td><td>71 - 76</td></tr>
                    <tr><td><b>S</b></td><td>69 - 74</td><td>76 - 81</td></tr>
                    <tr><td><b>M</b></td><td>76 - 81</td><td>76 - 81</td></tr>
                    <tr><td><b>L</b></td><td>84 - 89</td><td>81 - 86</td></tr>
                    <tr><td><b>XL</b></td><td>91 - 97</td><td>81 - 86</td></tr>
                    <tr><td><b>XXL</b></td><td>99 - 104</td><td>81 - 86</td></tr>
                  </tbody>
                </table>



              </div>





            </div>
          </div>
        </div>
        {/* size chart end */}

      </section>
      <div class="tf-toolbar-bottom type-1150">
        <div class="toolbar-item">
          <a style={{ color: "black" }} href="/">
            <div class="toolbar-icon">
              <IoHome />
            </div>
            <div class="toolbar-label">Home</div>
          </a>
        </div>
        <div class="toolbar-item">
          <a style={{ color: "black" }} href="/products" >
            <div class="toolbar-icon">
              <BiCategoryAlt />
            </div>
            <div class="toolbar-label">Shop</div>
          </a>
        </div>
        <div class="toolbar-item">
          <a style={{ color: "black" }} href="/SearchBar" >
            <div class="toolbar-icon">
              <IoSearchOutline />
            </div>
            <div class="toolbar-label">Search</div>
          </a>
        </div>
        <div class="toolbar-item">
          <a style={{ color: "black" }} href="/cart">
            <div class="toolbar-icon">
              <FaShoppingCart />
            </div>
            <div class="toolbar-label">Cart</div>
          </a>
        </div>
      </div>
    </>
  );
};

export default ProductPreview;
